import RouteNames from '../../../../../../app/router/_internals/RouteNames.enum';

export default Object.freeze({
	GENERAL: `${RouteNames.ROLES}-general`,
	ROLE_PERMISSIONS: `${RouteNames.ROLES}-role-permissions`,
	APPLICATIONS_ACCESS: `${RouteNames.ROLES}-application-access`,
});
